import React, { Component } from "react"
import {
  Dialog,
  Typography,
  DialogTitle,
  DialogContent,
  Divider,
  DialogActions,
  IconButton,
  Icon,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Checkbox,
  Button,
  Hidden,
} from "@material-ui/core"
import { withStyles } from "@material-ui/styles"
import styles from "./styles"
import classNames from "classnames"

export const statusFilterOptions = [
  {
    id: 1,
    type: "status",
    name: "Standby",
    description: "Shoots that are on standby",
    func: shoot => {
      return !shoot.firm && shoot.status !== "cancelled"
    },
  },
  {
    id: 2,
    type: "status",
    name: "Firm",
    description: "Shoots that are firm",
    func: shoot => {
      return shoot.firm && shoot.status !== "cancelled"
    },
  },
  {
    id: 3,
    type: "standard",
    name: "Wrapped",
    description: "Shoots that are wrapped",
    func: shoot => {
      return shoot.status === "wrapped" && shoot.status !== "cancelled"
    },
  },
  {
    id: 4,
    type: "standard",
    name: "Open",
    description: "Not all crew are firm",
    func: shoot => {
      return (
        shoot.roles.filter(y => !y.user_id).length > 0 &&
        shoot.status === "open" &&
        shoot.status !== "cancelled"
      )
    },
  },
  {
    id: 5,
    type: "standard",
    name: "Booked",
    description: "All crew are firm",
    func: shoot => {
      return shoot.status === "booked" && shoot.status !== "cancelled"
    },
  },
  {
    id: 7,
    type: "standard",
    name: "Cancelled",
    description: "Shoots marked as cancelled",
    func: shoot => {
      return shoot.status === "cancelled"
    },
  },
  {
    id: 8,
    type: "standard",
    name: "Billed",
    description: "Shoots that are billed",
    func: shoot => {
      return shoot.status === "billed" && shoot.status !== "cancelled"
    },
  },
  {
    id: 9,
    type: "standard",
    name: "Paid",
    description: "Shoots that are paid",
    func: shoot => {
      return shoot.status === "paid" && shoot.status !== "cancelled"
    },
  },
]

class FilterPreferencesDialog extends Component {
  state = {
    creatorsChecked: [],
    statusChecked: [],
    and: false,
    creatorsFilterOptions: [],
    switch: false,
    showOption: null,
    viewType: null,
  }

  componentDidMount() {
    const { creators } = this.props
    this.setState({
      creatorsFilterOptions: creators.map(creator => {
        return {
          ...creator,
          type: "creator",
          name: `${creator.first_name} ${creator.last_name}`,
          func: shoot => shoot.creator_id === creator.id,
        }
      }),
    })
  }

  componentDidUpdate(p) {
    if (!p.open && this.props.open) {
      const creatorsChecked = this.props.creatorFilters.map(x =>
        this.props.creators.findIndex(
          y => y.first_name + " " + y.last_name === x
        )
      )
      this.setState({
        statusChecked: this.props.filters.map(x =>
          statusFilterOptions.findIndex(y => x.name === y.name)
        ),
        and: this.props.and,
        creatorsChecked,
      })
    }
  }

  onChange = (data, apply = false) => {
    const { showOption } = this.state
    data.calendarOption = this.state.switch ? "listView" : "calendarView"
    let show = null
    if (this.state.switch) {
      showOption && showOption === "Day"
        ? (show = "listDay")
        : showOption === "Week"
          ? (show = "listWeek")
          : (show = "listMonth")
    } else {
      showOption && showOption === "Day"
        ? (show = "dayGridDay")
        : showOption === "Week"
          ? (show = "dayGridWeek")
          : (show = "dayGridMonth")
    }
    data.calendarViewOption = show

    let stringifyData = JSON.stringify(data)
    this.props.createDefaultFilters(stringifyData, apply)
  }

  closeDialog = () => {
    this.props.onClose()
    setTimeout(() => {
      this.setState({ creatorsChecked: [], statusChecked: [] })
    }, 300)
  }

  handleChangeViewShow = event => {
    this.setState({
      showOption: event.target.value,
    })
  }

  render() {
    const { props, state, onChange } = this
    const {
      open,
      onClose,
      onRemove,
      classes,
      calendarOption,
      calendarViewOption,
      defaultFilters,
    } = props
    const { creatorsChecked, statusChecked, creatorsFilterOptions } = state
    return (
      <Dialog
        onClose={this.closeDialog}
        open={open}
        fullScreen
        PaperProps={{ classes: { root: classes.dialogPaper } }}
      >
        <DialogTitle className={classes.dialogTitle}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Typography style={{ fontWeight: "bold", color: "white" }}>
              Default Filters
            </Typography>
            <div style={{ flexGrow: 1 }} />
            <IconButton onClick={onClose}>
              <Icon style={{ color: "white" }}>close</Icon>
            </IconButton>
          </div>
        </DialogTitle>
        <Divider />
        <DialogContent style={{ display: "flex" }}>
          <Hidden smDown>
            {/* WEB VIEW */}
            <List component="nav" style={{ marginRight: "10px" }}>
              <Typography component="p" className={classes.noteLineText}>
                Creators
              </Typography>
              <Divider />
              {creatorsFilterOptions.map((x, i) => {
                return (
                  <ListItem
                    style={{ marginRight: "128px" }}
                    key={i}
                    button
                    disableRipple
                    onClick={e => {
                      if (creatorsChecked.indexOf(i) >= 0) {
                        this.setState({
                          creatorsChecked: creatorsChecked.filter(x => x !== i),
                        })
                      } else {
                        this.setState({
                          creatorsChecked: creatorsChecked.concat([i]),
                        })
                      }
                    }}
                  >
                    <ListItemIcon>
                      <Checkbox
                        edge="start"
                        checked={creatorsChecked.indexOf(i) >= 0}
                        disableRipple
                        color="primary"
                      />
                    </ListItemIcon>
                    <ListItemText primary={x.name} secondary={x.description} />
                  </ListItem>
                )
              })}
            </List>

            <List component="nav" style={{ marginRight: "10px" }}>
              <Typography component="p" className={classes.noteLineText}>
                Shoot Status
              </Typography>
              <Divider />

              {statusFilterOptions.map((x, i) => {
                return (
                  <ListItem
                    style={{ marginRight: "128px" }}
                    key={i}
                    button
                    disableRipple
                    onClick={e => {
                      if (statusChecked.indexOf(i) >= 0) {
                        this.setState({
                          statusChecked: statusChecked.filter(x => x !== i),
                        })
                      } else {
                        this.setState({
                          statusChecked: statusChecked.concat([i]),
                        })
                      }
                    }}
                  >
                    <ListItemIcon>
                      <Checkbox
                        edge="start"
                        checked={statusChecked.indexOf(i) >= 0}
                        disableRipple
                        color="primary"
                      />
                    </ListItemIcon>
                    <ListItemText primary={x.name} secondary={x.description} />
                  </ListItem>
                )
              })}
            </List>
          </Hidden>
          {/* END WEB VIEW */}

          {/* MOBILE VIEW */}

          <Hidden mdUp>
            <List component="nav" style={{ marginRight: "10px" }}>
              <Typography component="p" className={classes.noteLineText}>
                Creators
              </Typography>
              <Divider />
              {creatorsFilterOptions.map((x, i) => {
                return (
                  <ListItem
                    style={{ marginRight: "128px" }}
                    key={i}
                    button
                    disableRipple
                    onClick={e => {
                      if (creatorsChecked.indexOf(i) >= 0) {
                        this.setState({
                          creatorsChecked: creatorsChecked.filter(x => x !== i),
                        })
                      } else {
                        this.setState({
                          creatorsChecked: creatorsChecked.concat([i]),
                        })
                      }
                    }}
                  >
                    <ListItemIcon>
                      <Checkbox
                        edge="start"
                        checked={creatorsChecked.indexOf(i) >= 0}
                        disableRipple
                        color="primary"
                      />
                    </ListItemIcon>
                    <ListItemText primary={x.name} secondary={x.description} />
                  </ListItem>
                )
              })}

              <Typography component="p" className={classes.noteLineTextMob}>
                Shoot Status
              </Typography>
              <Divider />

              {statusFilterOptions.map((x, i) => {
                return (
                  <ListItem
                    style={{ marginRight: "128px" }}
                    key={i}
                    button
                    disableRipple
                    onClick={e => {
                      if (statusChecked.indexOf(i) >= 0) {
                        this.setState({
                          statusChecked: statusChecked.filter(x => x !== i),
                        })
                      } else {
                        this.setState({
                          statusChecked: statusChecked.concat([i]),
                        })
                      }
                    }}
                  >
                    <ListItemIcon>
                      <Checkbox
                        edge="start"
                        checked={statusChecked.indexOf(i) >= 0}
                        disableRipple
                        color="primary"
                      />
                    </ListItemIcon>
                    <ListItemText primary={x.name} secondary={x.description} />
                  </ListItem>
                )
              })}
            </List>
          </Hidden>
          {/* END MOBILE VIEW */}

          {/* <List component="nav">

            <Typography
              component="p"
              className={classes.noteLineText}
            >
              View
            </Typography>
            <Divider />

            <ListItem>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-evenly",
                  margin: 20,
                }}
              >
                <Typography
                  className={classNames("", {
                    [classes.selectedDay]: !this.state.switch,
                    [classes.unselectedDay]: this.state.switch,
                  })}
                >
                  Calendar
                    </Typography>
                <Switch
                  checked={this.state.switch}
                  onChange={e => {
                    this.setState({
                      switch: !this.state.switch,
                    })
                  }}
                />
                <Typography
                  className={classNames("", {
                    [classes.selectedDay]: this.state.switch,
                    [classes.unselectedDay]: !this.state.switch,
                  })}
                >
                  List
                    </Typography>
              </div>
            </ListItem>

            <Typography
              component="p"
              className={classes.noteLineText}
            >
              Show
            </Typography>
            <Divider />


            <FormControl component="fieldset">
              <RadioGroup aria-label="gender" name="gender1" value={this.state.showOption}
                onChange={(e) => this.handleChangeViewShow(e)}
                classes={{
                  checked: classes.selectedOption, // class name, e.g. `classes-nesting-root-x`
                }}
              >
                <FormControlLabel value="Day" control={<Radio />} label="Day" />
                <FormControlLabel value="Week" control={<Radio />} label="Week" />
                <FormControlLabel value="Month" control={<Radio />} label="Month" />
              </RadioGroup>
            </FormControl>

          </List> */}
        </DialogContent>
        <DialogActions>
          <div style={{ flexGrow: 1 }} />
          {defaultFilters && (
            <Button
              variant="text"
              color="primary"
              onClick={e => {
                onRemove()
                this.closeDialog()
              }}
            >
              Remove Default Filters
            </Button>
          )}
          <Button
            onClick={e => {
              onChange({
                statusOptions: statusFilterOptions.filter(
                  (x, i) => statusChecked.indexOf(i) >= 0
                ),
                creatorsOptions: creatorsFilterOptions.filter(
                  (x, i) => creatorsChecked.indexOf(i) >= 0
                ),
              })
              this.closeDialog()
            }}
            variant="contained"
            color="primary"
          >
            Save
          </Button>
          <Button
            onClick={e => {
              onChange(
                {
                  statusOptions: statusFilterOptions.filter(
                    (x, i) => statusChecked.indexOf(i) >= 0
                  ),
                  creatorsOptions: creatorsFilterOptions.filter(
                    (x, i) => creatorsChecked.indexOf(i) >= 0
                  ),
                },
                true
              )
              this.closeDialog()
            }}
            variant="contained"
            color="primary"
          >
            Save and Apply
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export default withStyles(styles)(FilterPreferencesDialog)
